module.exports = __webpack_public_path__ + "static/media/ic_draft.5b2ce3ce.svg";